"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsDirectDiscount = exports.getProductDirectDiscount = void 0;
const discounts_helper_1 = require("./discounts-helper");
/**
 * Calculates a single product direct discount
 * (e.g: *This product ORIGINAL PRICE was 50€
 * but now its SALE PRICE is 35€*).
 *
 * If `productDiscountedPrice` is provided and SMALLER THAN
 * `productPrice`, it will be used. Otherwise, `productPrice`
 * will be used.
 *
 * @returns The discounted information like how much discount
 * was applied, the total value after discount, and the subtotal
 * value before discount.
 */
const getProductDirectDiscount = (product) => {
    // console.log('product: ', product);
    const absoluteTotal = product.productPrice * product.quantity;
    // If the product has a discounted price, and it lower than the original price, apply it
    const discountedTotal = (product.productDiscountedPrice && product.productDiscountedPrice < product.productPrice ? product.productDiscountedPrice : product.productPrice) * product.quantity;
    const discountAmount = absoluteTotal - discountedTotal;
    const discountedProduct = (0, discounts_helper_1.buildEmptyDiscountedProduct)(product.productId);
    return Object.assign(Object.assign({}, discountedProduct), { lineItemSubtotal: discountedTotal, subtotal: discountedTotal, total: discountedTotal, discounts: Object.assign(Object.assign({}, discountedProduct.discounts), { direct: {
                subtotal: absoluteTotal,
                discountAmount,
                total: discountedTotal,
            } }) });
};
exports.getProductDirectDiscount = getProductDirectDiscount;
/**
 * Calculates product direct discount from a list, return a list of
 * discounted products and its summary (total and discount values).
 *
 * Check the `getProductDirectDiscount` method for more details.
 */
const getProductsDirectDiscount = (products) => products.reduce((acc, product) => {
    const discountedProduct = (0, exports.getProductDirectDiscount)(product);
    return (0, discounts_helper_1.buildProductsDiscountSummary)(acc, discountedProduct);
}, { products: [], lineItemSubtotal: 0, subtotal: 0, total: 0, discounts: { direct: 0, bulk: 0, store: 0 } });
exports.getProductsDirectDiscount = getProductsDirectDiscount;
